import { render, staticRenderFns } from "./descriptionList.vue?vue&type=template&id=1bad5cbe&"
import script from "./descriptionList.vue?vue&type=script&lang=js&"
export * from "./descriptionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports